(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var _swiper = require('swiper');

var _swiper2 = _interopRequireDefault(_swiper);

var _svg4everybody = require('svg4everybody');

var _svg4everybody2 = _interopRequireDefault(_svg4everybody);

var _scrollToElement = require('scroll-to-element');

var _scrollToElement2 = _interopRequireDefault(_scrollToElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(0, _svg4everybody2.default)();

var mainSlider = new _swiper2.default('.slider__content.swiper-container', {
    speed: 1000,
    slidesPerView: 1,
    loop: true,
    spaceBetween: 0,
    centeredSlides: true,
    preloadImages: true,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
    },
    lazy: {
        loadPrevNext: true
    },
    navigation: {
        nextEl: '.carousel__nav-next',
        prevEl: '.carousel__nav-prev'
    },
    disableOnInteraction: true,
    autoplay: false
});

var overlay = new _swiper2.default('.slider__overlay .swiper-container', {
    speed: 2000,
    slidesPerView: 1,
    loop: true,
    spaceBetween: 0,
    centeredSlides: true,
    preloadImages: true,
    allowTouchMove: false,
    disableOnInteraction: true,
    lazy: {
        loadPrevNext: true
    },
    autoplay: false
});

var scrollLinks = [].concat(_toConsumableArray(document.querySelectorAll('.js-scroll-to')));

scrollLinks.forEach(function (scrollLink) {
    scrollLink.addEventListener('click', function (e) {
        e.preventDefault();
        var targetId = scrollLink.getAttribute('href');
        var scrollTarget = document.querySelector(targetId);
        if (scrollTarget) {
            (0, _scrollToElement2.default)(scrollTarget);
        }
    });
});

mainSlider.controller.control = overlay;

var mediaTriggers = [].concat(_toConsumableArray(document.querySelectorAll('.js-media-play')));

mediaTriggers.forEach(function (el) {
    el.addEventListener('click', function () {
        var component = el.closest('.js-media');
        var mediaId = component.dataset.mediaId;

        var mediaPlaceholder = component.querySelector('.js-media-embed');

        if (mediaId) {
            component.classList.add('media--is-playing');
            mediaPlaceholder.innerHTML = '<iframe src="https://www.youtube.com/embed/' + mediaId + '?autoplay=1&modestbranding=1&fs=0&controls=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
        }
    });
});

mainSlider.on('slideChange', function () {
    mediaTriggers.forEach(function (el) {
        var component = el.closest('.js-media');
        var mediaPlaceholder = component.querySelector('.js-media-embed');
        component.classList.remove('media--is-playing');
        mediaPlaceholder.innerHTML = '';
    });
});

},{"scroll-to-element":"scroll-to-element","svg4everybody":"svg4everybody","swiper":"swiper"}]},{},[1]);
